export default function initAccountMenu() {
    document.querySelectorAll('.ria-account-menu').forEach(function (menu) {
        const trigger = menu.querySelector('.ria-account-trigger');
        const panel = menu.querySelector('.ria-account-panel');
        if (!trigger || !panel) return;

        function setOpen(open, restoreFocus) {
            trigger.setAttribute('aria-expanded', String(open));
            panel.hidden = !open;
            if (restoreFocus) trigger.focus();
        }

        trigger.addEventListener('click', function () {
            setOpen(panel.hidden, false);
        });

        menu.addEventListener('keydown', function (event) {
            const links = Array.from(panel.querySelectorAll('a[href]'));
            if (event.key === 'Escape' && !panel.hidden) {
                event.preventDefault();
                setOpen(false, true);
            } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
                if (!links.length) return;
                event.preventDefault();
                setOpen(true, false);
                const index = links.indexOf(document.activeElement);
                const next = event.key === 'ArrowDown'
                    ? (index + 1) % links.length
                    : (index <= 0 ? links.length - 1 : index - 1);
                links[next].focus();
            }
        });

        menu.addEventListener('focusout', function (event) {
            if (!menu.contains(event.relatedTarget)) setOpen(false, false);
        });

        document.addEventListener('click', function (event) {
            if (!menu.contains(event.target)) setOpen(false, false);
        });

        window.addEventListener('resize', function () {
            setOpen(false, false);
        });
    });
}
